


























































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import ContactLensItemDetailStore from './store'

@Component
/**
 * Safari(iOS, Mac共に)ではセレクトボックス内の中央寄せに対応していない。
 * そのため、中央寄せするために、このコンポーネントではセレクトボックスのopacityを0にして、その上に表示用の要素をオーバーレイすることで、中央寄せを可能にしている。
 * 留意事項1: 純粋にCSSで解決できればassetsの方でスタイル定義してより汎用的なものとしたいが、表示用の要素のテキストをJSで書き換えているため、Vue側でスタイル定義も行っている。
 * 留意事項2: Safariの場合に中央寄せしたい、というユースケースが広く見られる場合は、Vueコンポーネントとしてもより汎用化したい。
 */
export default class ContactLensQuantityDropdown extends Vue {
  @Prop({ required: true })
  id: string

  @Prop({ required: true })
  store: ContactLensItemDetailStore | null

  @Prop({ required: true })
  isLoading: boolean

  get selectBoxClass(): string[] {
    return [
      'dropdown', 'dropdown--quantity',
    ]
  }

  /**
   * セレクトボックス本体を隠して、（中央寄せのために）オーバーレイ表示されるDOM要素のテキスト
   */
  get overlayLabel(): number {
    return this.selectedQuantity
  }

  get selectedQuantity(): number {
    return this.store ? this.store.selectedQuantity : 0
  }

  get maxSelectableQuantity(): number {
    return this.store ? this.store.maxSelectableQuantity : 0
  }

  onChange($event): void {
    if (this.store) {
      this.store.selectQuantity($event.target.value)
    }
  }
}
